module.exports = __webpack_public_path__ + "img/aidmodel_lg.b613cd94.png";